// Rubriken der Projekte-Seite und der Startseiten-Kacheln:
// feste Reihenfolge und Beschriftungen (DE), EN läuft über i18n t()
export const ART_ORDER = { dining: 0, hotel: 1, reise: 2 };
export const ART_LABEL = { dining: "Restaurants", hotel: "Hotels", reise: "Reisen" };
export const ART_SUB = {
  dining: "Küchen, Tische, Menschen",
  hotel: "Zimmer, Lobbys, stille Ecken",
  reise: "Küsten, Straßen, weite Blicke",
};

// Serien, die wie eine Rubrik heißen (z. B. „HOTEL", „Reise"), bekommen
// überall die Rubrik-Beschriftung im Plural: Restaurants, Hotels, Reisen
const CAT_NAMES = new Set(["restaurant", "restaurants", "hotel", "hotels", "reise", "reisen", "travel"]);
export const isCategorySeries = (name) => CAT_NAMES.has((name || "").trim().toLowerCase());
